import { render } from "./Conflicts.vue?vue&type=template&id=00e21644&scoped=true&ts=true&lang=pug"
import script from "./Conflicts.vue?vue&type=script&lang=ts"
export * from "./Conflicts.vue?vue&type=script&lang=ts"

import "./Conflicts.vue?vue&type=style&index=0&id=00e21644&lang=css&scoped=true"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00e21644"]])

export default __exports__